import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'home',
        link: '/',
    },
    {
        id: 2,
        label: 'MENUITEMS.MISCITAS.TEXT',
        icon: 'home',
        link: '/',
    },
    {
        id: 2,
        label: 'MENUITEMS.MISPAGOS.TEXT',
        icon: 'home',
        link: '/',
    },
    {
        id: 2,
        label: 'MENUITEMS.NOTIFICAIONES.TEXT',
        icon: 'home',
        link: '/',
    },
    {
        id: 2,
        label: 'MENUITEMS.PERFIL.TEXT',
        icon: 'home',
        link: '/',
    },
    {
        id: 2,
        label: 'MENUITEMS.HISTORIALCITAS.TEXT',
        icon: 'home',
        link: '/',
    },
    {
        id: 8,
        label: 'MENUITEMS.DIARIOEMOCIONES.TEXT',
        icon: 'heart',
        link: '/diario-emociones',
    },
    {
        id: 2,
        label: 'MENUITEMS.SALIR.TEXT',
        icon: 'home',
        link: '/',
    },
    
    
];

